import styled from 'styled-components';

import Aqua from 'assets/aqua/aqua-logo.svg';

import { cardBoxShadow, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Container = styled.section`
    position: relative;
    height: 20rem;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        padding: 0 1.6rem;
        max-width: 55rem;
        height: initial;
    `}
`;

export const Card = styled.div`
    position: relative;
    display: flex;
    width: 58rem;
    align-items: flex-start;
    padding: 6rem 5.8rem;
    margin-top: -7rem;
    background: ${COLORS.white};
    ${cardBoxShadow};
    border-radius: 0.5rem;

    &:first-child {
        margin-right: 6rem;
    }

    ${respondDown(Breakpoints.lg)`
        width: 40rem;
        padding: 4rem 3.8rem;
    `}

    ${respondDown(Breakpoints.md)`
        width: 100%;
        max-width: 43rem;
        margin-bottom: 0.8rem;
        margin-top: 0;
        margin-right: 0 !important;

        & > div {
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
        }
    `}
`;

export const AquaLogo = styled(Aqua)`
    width: 3.3rem;
    height: 3.3rem;
    margin: 0.4rem 1.6rem 0 0;

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

export const Amount = styled.div`
    display: flex;
    align-items: center;
    min-height: 4.2rem;
    font-size: 3.6rem;
    font-weight: 400;
    line-height: 4.2rem;
    letter-spacing: 0;
    margin-bottom: 0.6rem;

    ${respondDown(Breakpoints.md)`
        min-height: 3rem;
        font-size: 1.8rem;
        font-weight: 700;
        line-height: 3rem;
    `}
`;

export const Description = styled.div`
    font-size: 1.8rem;
    font-weight: 400;
    line-height: 3.2rem;
    letter-spacing: 0;

    ${respondDown(Breakpoints.md)`
        font-size: 1.4rem;
        line-height: 2.5rem;
    `}
`;
